module.exports = __webpack_public_path__ + "images/ratepay.760da28b7feb9d342e4f898a8580e2c1.svg";